import { FC } from 'react';
import styles from './FormSuccess.module.css';
import { CheckCircleIcon, IconSize } from '@lifechurch/react-ion';

const FormSuccess: FC<{ message: string }> = ({ message }) => {
  return (
    <div className={styles['wrapper']}>
      <div className='mr-2'>
        <CheckCircleIcon color='#0ac1a1' size={IconSize.XL} />
      </div>
      {message}
    </div>
  );
};

export default FormSuccess;
